import { render, staticRenderFns } from "./TeacherAnnouncement.vue?vue&type=template&id=04a5497c&scoped=true&"
import script from "./TeacherAnnouncement.vue?vue&type=script&lang=js&"
export * from "./TeacherAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./TeacherAnnouncement.vue?vue&type=style&index=0&id=04a5497c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a5497c",
  null
  
)

export default component.exports